let connectName = "dshs-altsa-hcs";
  let loginUrl = "https://d-926702479b.awsapps.com/start/#/saml/default/DSHS-ALTSA-HCS/ins-be15b1e5f63f023a";
  let region = "us-west-2";

  // set default values
  export const CONNECT_NAME = connectName.includes("<") ? "company-name-connect-dev" : connectName;
  export const CONNECT_URL = "https://" +CONNECT_NAME + ".my.connect.aws/connect/";
  export const CCP_URL = "https://" + CONNECT_NAME + ".my.connect.aws/connect/ccp-v2";
  export const LOGIN_URL = loginUrl.includes("<") ? "NA" : loginUrl;
  export const REGION = region.includes("<") ? "NA" : region;